import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import SplashLoading from "./components/SplashLoading";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

import "./i18n";
import { ClearCacheProvider } from "react-clear-cache";
const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
	<StrictMode>
		<ClearCacheProvider>
			<Suspense fallback={<SplashLoading />}>
				<App />
			</Suspense>
		</ClearCacheProvider>
	</StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

declare global {
	interface Window {
		global: any;
	}
}

if (typeof window !== "undefined") {
	window.global = window;
}
